import React from 'react';
import RegistrationFormProps from '../registration.types';
import NewUserIdentity from './NewUserIdentity';
import { BUSINESS_REGISTRATION_TYPE } from '../registration.rules';
import BusinessRegistrationTypeToggle from '../BusinessRegistrationTypeToggle';
import NewBusinessIdentity from './NewBusinessIdentity';
import { Box } from '@material-ui/core';
import { OnlineRegistrationType } from '../../../__generated__/pge-types';

interface NewIdentityVerificationProps extends RegistrationFormProps {
  classes: any;
}

const NewIdentityVerification = (props: NewIdentityVerificationProps) => {
  const { form } = props;

  const isBusinessRegistration =
    form.values.registrationType === OnlineRegistrationType.Commercial;

  const isUserForBusiness =
    isBusinessRegistration &&
    form.values.businessRegistrationType ===
      BUSINESS_REGISTRATION_TYPE.UserForBusiness;

  const isBusinessEntity =
    isBusinessRegistration &&
    form.values.businessRegistrationType ===
      BUSINESS_REGISTRATION_TYPE.BusinessEntity;

  return (
    <Box>
      {isBusinessRegistration && <BusinessRegistrationTypeToggle {...props} />}

      {/* Get complete user details for residential & user for business scenarios */}
      {(!isBusinessRegistration || isUserForBusiness) && (
        <NewUserIdentity {...props} />
      )}

      {isBusinessEntity && <NewBusinessIdentity {...props} />}
    </Box>
  );
};

export default NewIdentityVerification;
